<template>
  <b-modal
    v-model="showModal"
    title="Chi tiết đơn trả hàng"
    size="lg"
    ok-only
    ok-variant="primary"
    ok-title="Đóng"
    hide-backdrop
    @hidden="onHidden"
  >
    <div v-if="loading" class="text-center py-4">
      <b-spinner class="align-middle"></b-spinner>
      <span class="ml-2">Đang tải...</span>
    </div>
    <div v-else-if="error" class="text-center py-4">
      <b-alert show variant="danger">{{ error }}</b-alert>
    </div>
    <div v-else-if="detail" class="return-detail">
      <b-row class="mb-2">
        <b-col md="4"><strong>Mã đơn trả:</strong></b-col>
        <b-col md="8">{{ detail.return_sn || '-' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Mã đơn gốc:</strong></b-col>
        <b-col md="8">{{ detail.order_sn || '-' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Trạng thái:</strong></b-col>
        <b-col md="8">
          <b-badge variant="info">{{ detail.status || '-' }}</b-badge>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Số tiền hoàn:</strong></b-col>
        <b-col md="8">{{ formatAmount(detail.refund_amount) }} {{ detail.currency || '' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Lý do trả:</strong></b-col>
        <b-col md="8">{{ detail.text_reason || detail.reason || '-' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Mã vận đơn:</strong></b-col>
        <b-col md="8">{{ detail.tracking_number || '-' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Ngày tạo:</strong></b-col>
        <b-col md="8">{{ formatUnixTime(detail.create_time) }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Ngày cập nhật:</strong></b-col>
        <b-col md="8">{{ formatUnixTime(detail.update_time) }}</b-col>
      </b-row>
      <template v-if="detail.user">
        <hr />
        <h6>Thông tin người mua</h6>
        <b-row class="mb-2">
          <b-col md="4"><strong>Username:</strong></b-col>
          <b-col md="8">{{ detail.user.username || '-' }}</b-col>
        </b-row>
        <b-row v-if="detail.user.email" class="mb-2">
          <b-col md="4"><strong>Email:</strong></b-col>
          <b-col md="8">{{ detail.user.email }}</b-col>
        </b-row>
      </template>
      <template v-if="detail.item && detail.item.length > 0">
        <hr />
        <h6>Sản phẩm trả</h6>
        <b-table
          :items="detail.item"
          :fields="itemFields"
          small
          striped
          responsive
          show-empty
          empty-text="Không có sản phẩm"
        >
          <template #cell(name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(amount)="data">
            {{ data.value ?? '-' }}
          </template>
          <template #cell(item_price)="data">
            {{ formatAmount(data.value) }}
          </template>
          <template #cell(refund_amount)="data">
            {{ formatAmount(data.value) }}
          </template>
        </b-table>
      </template>
    </div>
  </b-modal>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { CLIENT_DATE_TIME } from '@/utils/date';
import { convertPrice } from '@/utils/common';
const moment = require('moment');
const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin');

export default {
  name: 'ReturnDetailModal',
  data() {
    return {
      showModal: false,
      loading: false,
      error: null,
      detail: null,
      itemFields: [
        { key: 'name', label: 'Tên sản phẩm', thStyle: { width: '40%' } },
        { key: 'amount', label: 'SL', thStyle: { width: '10%' }, tdClass: 'text-center' },
        { key: 'item_price', label: 'Đơn giá', thStyle: { width: '20%' }, tdClass: 'text-right' },
        { key: 'refund_amount', label: 'Hoàn tiền', thStyle: { width: '20%' }, tdClass: 'text-right' },
      ],
    };
  },
  methods: {
    formatAmount(value) {
      if (value === null || value === undefined) return '-';
      return convertPrice(value);
    },
    formatUnixTime(timestamp) {
      if (!timestamp) return '-';
      return moment.unix(timestamp).format(CLIENT_DATE_TIME);
    },
    onHidden() {
      this.detail = null;
      this.error = null;
    },
    async open({ returnSn, connectionId }) {
      if (!returnSn || !connectionId) {
        this.error = 'Thiếu thông tin đơn trả hàng hoặc kết nối sàn';
        this.showModal = true;
        return;
      }
      this.showModal = true;
      this.loading = true;
      this.error = null;
      this.detail = null;
      try {
        this.detail = await shopeeAdminRepo.getReturnDetail({ returnSn, connectionId });
      } catch (err) {
        this.error = err.response?.data?.message || err.message || 'Không thể tải chi tiết đơn trả hàng';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.return-detail {
  font-size: 14px;
}
</style>
